












































































































































































/*
  getParam 获取命题教师聘用页面参数
  getPropositionTchEmploy 获取命题教师聘用分页列表
  printOffer 打印聘书
  getMsgTeacher 获取短信教师名单
*/
import { Vue, Component } from "vue-property-decorator";
//引入接口调用函数
import {
  getParam,
  getPropositionTchEmploy,
  printOffer,
  getMsgTeacher,
  deleteInfo
} from "../../../api/propositionTeacherEmploy";
//引入导入、导出、下载的处理函数
import importAndExportMixin from "../../../mixins/importAndExport";

//自定义的form对象接口
interface CustomForm {
  [propName: string]: any;
}

@Component({
  name: "propositionTeacherEmploy",
  components: {
    sendMessage: () =>
      import("../../baseInfo/teacherInfoManage/modules/sendMessage.vue"),
    UploadProgress: () => import("@/components/UploadProgress/index.vue"),
  },
  mixins: [importAndExportMixin]
})
export default class extends Vue {
  private projectId: string = ""; //项目
  private subjectId: string = ""; //科目
  private employStatus: string = ""; //聘用状态
  private teacherName: string = ""; //命题教师
  private showTableLoading: boolean = false; //是否显示列表loading
  private tableData: object[] = []; //列表数据
  private pageNo: number = 1; //当前页码
  private pageSize: number = 10; //当前条目
  private total: number = 0; //总条数
  private chooseArray: object[] = []; //勾选的数据集合
  private showContract: boolean = false; //是否显示"聘书"弹窗
  private currentInfo: CustomForm = {}; //当前勾选的单条数据（打印聘书窗口的数据）
  private showSendMessage: boolean = false; //是否显示发送短息弹窗
  //页面参数
  private projects: object[] = []; //项目数组
  private subjects: object[] = []; //项目数组
  private treeVos: object = {}; //收件人
  private tableHeight: number = 0;
  public $refs!: {
    table: HTMLFormElement;
  };
  private iframe:any = null  //装载pdf的iframe对象
  private uploadData = {progressId: -1, projectId: this.projectId}; // 文件上传入参
  created() {
    //获取页面参数
    this.getParams();
    //获取列表
    this.getData();
  }

  mounted() {
    setTimeout(() => {
      this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 80;
      if (this.tableHeight < 300) { this.tableHeight = 300; }
    }, 100);
  }

  //上传地址
  get uploadUrl() {
    return window.config.baseUrl4Shool + "/propositionteacher/propositionTchEmploy/upload";
  }

  // 根据分页计算页码
  private indexMethod(index) {
    return index + 1 + (this.pageNo - 1) * this.pageSize;
  }

  //获取页面参数
  private async getParams() {
    try {
      let res = await getParam();
      this.projects = res.data.projects;
      this.subjects = res.data.subjects;
    } catch (error) {
      // this.$message.error(error || "获取数据失败");
      this[`$message`]({
        type: "error",
        message: error!.mesg ? error!.mesg : error
      });
    }
  }

  //getPropositionTchEmploy 和 exportPropositionTeacherEmploy 接口的传参
  private getRequestParams() {
    return {
      current: this.pageNo, //当前页
      size: this.pageSize, //记录数
      employState: this.employStatus, //聘用状态 0:已聘用 1:作废聘用
      projectId: this.projectId, //项目id
      subjectId: this.subjectId, //科目id
      teacherName: this.teacherName //教师姓名
    };
  }

  //获取列表数据
  private async getData() {
    this.showTableLoading = true;
    try {
      let res = await getPropositionTchEmploy(this.getRequestParams());
      this.showTableLoading = false;
      this.tableData = res.data.records;
      this.total = res.data.total;
    } catch (error) {
      this.showTableLoading = false;
      // this.$message.error(error || "获取数据失败");
      this[`$message`]({
        type: "error",
        message: error!.mesg ? error!.mesg : error
      });
    }
  }

  //搜索查询
  private searchHandle() {
    this.pageNo = 1;
    this.getData();
  }

  //勾选处理
  private selectChangeHandle(v: object[]) {
    //记录勾选时的单条数据
    this.currentInfo = v[0];
    //保存勾选的教师数据
    this.chooseArray = v.map((item: any) => {
      return {
        projectId:  item['projectId'], // 项目id
        subjectId: item[`subjectId`], //科目id
        teacherId:  item[`teacherId`] // 教师id
      }
    });
  }

  //返回列表页
  private goBack(){
    if (this.iframe && this.iframe.src) {
      window.URL.revokeObjectURL(this.iframe.src);
    }

    this.$refs['iframeContainer'].removeChild(this.iframe);
    this.iframe = null
  }

 //预览pdf
 private previewPDF(res){
    //创建一个iframe
    this.iframe = document.createElement("iframe");
    this.iframe.setAttribute("frameborder", 0);
    this.iframe.style.width = "100%";
    this.iframe.style.height = "100%";
    this.$refs['iframeContainer'].appendChild(this.iframe);
    this.iframe.src = window.URL.createObjectURL(res)
  }
  //清空表格选中
  private clearSelection(){
    this.$refs['table'].clearSelection()
  }

  //“打印聘书”处理
  private async printHandle() {
    if (this.chooseArray.length <= 0) {
      this.$message.warning("请勾选教师！");
      return false;
    }
    try {
      let res = await printOffer(this.chooseArray);
      //打印成功，显示聘书
       this.clearSelection() //清空选择
       this.previewPDF(res) //预览pdf
    } catch (error) {
      this.clearSelection() //清空选择
      // this.$message.error(error || "操作失败");
      this[`$message`]({
        type: "error",
        message: error!.mesg ? error!.mesg : error
      });
    }
  }

  // 点击“发送短信息”，获取短信教师名单
  private async getNameList () {
    try {
      const res = await getMsgTeacher(this.getRequestParams());
      this.treeVos = res.data;
      this.showSendMessage = true;
    } catch (error) {
      this.$message.error(error.mesg || "获取教师名单失败");
    }
  }

  //关闭聘书处理
  private closeContract() {
    this.showContract = false;
    //刷新列表
    this.getData();
  }

  //删除处理
  private deleteHandle() {
    if (this.chooseArray.length <= 0) {
      this.$message.warning("请勾选教师！");
      return false;
    }
    //询问是否删除
    this.$confirm("确定删除?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    }).then(async () => {
      try {
        await deleteInfo(this.chooseArray);
        this.$message.success("删除成功");
        //操作成功，重新获取列表
        this.getData();
      } catch (error) {
        this.$message.error(error.mesg || error || "删除失败");
      }
    });
  }

  // 每页条目变化时
  private handleSizeChange(val: number): void {
    this.pageSize = val;
    this.getData();
  }
  // 当前页发生改变时
  private handleCurrentChange(val: number): void {
    this.pageNo = val;
    this.getData();
  }
}
